import {Point} from './../../../lib/objects/Point';

export const renderArrow = (region, pointList, scale = 1, viewZoom = undefined) => {
  // An arrow is just two points with a tip. The shape information for the arrow's tip is not saved to the database so
  // we have a little extra work to do. To simplify we draw a vertical arrow and then scale / rotate it to match the
  // length / angle of the line between the two points saved in the database.

  const origin = new Point().setPoint(pointList[0]);
  const endpoint = new Point().setPoint(pointList[1]);

  // 1. Draw the tip in its baseline position.
  //    Since the tip is manually generated we have to scale it manually too (IE tipZoom !== viewZoom).
  const tipScale = (region.zoom && viewZoom) ? region.zoom / viewZoom : 1;
  const tipWidth = 4 * tipScale;
  const tipLength = 12 * tipScale;
  const tipXY = `${tipWidth},${tipLength}`;
  const tipPath = `M 0,0 L ${tipXY} L -${tipXY}`;

  // 2. Draw the shaft in its baseline position.
  const arrowLength = (region.data.lengthPixels || origin.distance(endpoint));

  // 3. Put the tip on the shaft.
  const svgPath = `M 0,0 L 0,${arrowLength * scale} ${tipPath} Z`;

  // 4. Calculate the angle of rotation
  const deltaX = origin.x - endpoint.x;
  const deltaY = origin.y - endpoint.y;
  const angle = (Math.atan2(deltaY, deltaX) * 180 / Math.PI) + 90; // +90 because the baseline position is vertical

  // 5. Calculate the offset.
  //    Our baseline Arrow's coordinates are 0,0, so we apply a transformation to move it to the position indicated by
  //    the origin.
  const offset = `${origin.x * scale},${origin.y * scale}`;
  // By default, Raphael rotates around the center of the arrow's bounding box. We decorate angle with 0,0 to tell
  // Raphael to rotate at the tip instead.
  const svgTransformation = `t${offset} r${angle},0,0`;

  return {svgPath, svgTransformation};
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/drawings/arrow.js